// components/HeroSection/FloatingIcons.js
import React from "react";
import { motion } from "framer-motion";

const FloatingIcons = () => {
  const icons = [
    { icon: "🏠", x: "10%", y: "20%", delay: 0 },
    { icon: "🎮", x: "85%", y: "30%", delay: 0.5 },
    { icon: "🧹", x: "15%", y: "70%", delay: 1 },
    { icon: "🌙", x: "80%", y: "60%", delay: 1.5 },
    { icon: "👥", x: "50%", y: "85%", delay: 2 },
    { icon: "💫", x: "70%", y: "15%", delay: 2.5 },
  ];

  return (
    <>
      {icons.map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: item.delay, duration: 0.8 }}
          style={{
            position: "absolute",
            left: item.x,
            top: item.y,
            fontSize: "2rem",
            zIndex: 1,
          }}
        >
          <motion.div
            animate={{
              y: [0, -20, 0],
              rotate: [0, 5, -5, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
            whileHover={{ scale: 1.5, rotate: 360 }}
          >
            {item.icon}
          </motion.div>
        </motion.div>
      ))}
    </>
  );
};

export default FloatingIcons;